module.exports = "/images/edit-icon-white.svg?d06c5b30317d75db3ef537219efdb9f1";